import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';
import { UserService } from 'src/app/service/user.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-page-contact-two',
  templateUrl: './page-contact-two.component.html',
  styleUrls: ['./page-contact-two.component.css']
})
export class PageContactTwoComponent implements OnInit {

  contactForm: any;

  constructor(private formBuilder: FormBuilder, private userService: UserService, private datePipe: DatePipe,
              private route: Router, private scrollToService: ScrollToService,) {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      coment: ['', Validators.required],
    });
  }

  sendmail() {
    let req = {
      customerDTO: {
        clientEmail: this.contactForm.controls.email.value,
        clientName: this.contactForm.controls.name.value,
      },
      inquiry:this.contactForm.controls.coment.value,
    };

    this.userService.contact(req).subscribe(
        res=>{
          if (res.responseCode == 200) {
            Swal.fire(
                'Success!',
                'Message send successfully',
                'success'
            )
            this.route.navigate(['/']);
          } else {
            Swal.fire(
                'Faild !',
                'somthing went wrong please try again',
                'error'
            )
          }
        }
    )
  }

  ngOnInit(): void {
    this.triggerScrollTo();
  }


  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };
    this.scrollToService.scrollTo(config);
  }
}
